import { render, staticRenderFns } from "./ViewRecord.vue?vue&type=template&id=33b5a754&scoped=true"
import script from "./ViewRecord.vue?vue&type=script&lang=js"
export * from "./ViewRecord.vue?vue&type=script&lang=js"
import style0 from "./ViewRecord.vue?vue&type=style&index=0&id=33b5a754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b5a754",
  null
  
)

/* custom blocks */
import block0 from "./ViewRecord.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports